import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modalBtnContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(6)
  },
  modalHeader: {
    marginBottom: theme.spacing(6)
  },
  modalContent: {
    lineHeight: 1.2,
    display: 'block'
  },
  modalCloseButton: {
    marginRight: theme.spacing(8)
  },
  btn: {
    fontWeight: 500,
    fontSize: 16,
    padding: theme.spacing(4)
  }
}));

export default useStyles;
